<template>
  <div class="main-container" style="padding:16px">

    <!-- 头部部分 -->
    <div ref="search_d">
      <el-row>
        <el-form label-width="120px">
          <!-- <el-col :span="6">
            <el-form-item label="到期时间">
              <el-date-picker v-model="overDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                value-format="yyyy-MM-dd" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="商家名称">
              <el-input v-model="queryInfo.condition.merchantName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商家编码">
              <el-input v-model="queryInfo.condition.merchantCode" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-button type="primary" class="ml10" @click="search">
            搜 索
          </el-button>
          <el-button @click="reset"> 重 置 </el-button>
        </el-form>
      </el-row>
      <el-row>
        <el-col :span="18">
          <el-button type="primary" @click="newBtn">新建</el-button>
        </el-col>
      </el-row>
    </div>

    <!-- 表格部分 -->
    <div>
      <el-table border ref="table" v-loading="loading" :data="tableData" tooltip-effect="dark" style="width: 100%" :height="height">
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>

                  <!-- <el-table-column label="id" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.id }}</template>
          </el-table-column> -->
          <el-table-column label="商家编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.merchantCode }}</template>
          </el-table-column>
          <el-table-column label="商家名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.merchantName }}</template>
          </el-table-column>
          <!-- <el-table-column label="入驻类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.settleType }}</template>
          </el-table-column> -->
          <el-table-column label="联系人" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.linkName }}</template>
          </el-table-column>
          <el-table-column label="联系手机号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.linkPhone }}</template>
          </el-table-column>
          <el-table-column label="营业时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.openingTime }}</template>
          </el-table-column>
          <el-table-column label="营业地址" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.address }}</template>
          </el-table-column>
          <el-table-column label="商家描述" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.merchantDesc }}</template>
          </el-table-column>
          <!-- <el-table-column label="营业执照" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.businessLicense }}</template>
          </el-table-column> -->
          <!-- <el-table-column label="入驻支付类型" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.payType }}</template>
          </el-table-column> -->
          <el-table-column label="状态" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.status }}</template>
          </el-table-column>
          <el-table-column label="创建日期" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.createDt }}</template>
          </el-table-column>
          <el-table-column label="商家logo" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.logo }}</template>
          </el-table-column>
          <el-table-column label="创建人" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.creator }}</template>
          </el-table-column>
          <el-table-column label="纬度" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.latitude }}</template>
          </el-table-column>
          <el-table-column label="经度" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.longitude }}</template>
          </el-table-column>
          <!-- <el-table-column label="通用费率" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.generalRate }}</template>
          </el-table-column>
          <el-table-column label="微信费率" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.wxRate }}</template>
          </el-table-column>
          <el-table-column label="支付宝费率" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.alipayRate }}</template>
          </el-table-column>
          <el-table-column label="线上订单流水号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.onlineTransNo }}</template>
          </el-table-column> -->
          <!-- <el-table-column label="是否发送短信：" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.isSms }}</template>
          </el-table-column>
          <el-table-column label="温馨提示" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.reminder }}</template>
          </el-table-column>
          <el-table-column label="关闭开始时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.closeStartTime }}</template>
          </el-table-column>
          <el-table-column label="关闭结束时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.closeEndTime }}</template>
          </el-table-column>
          <el-table-column label="关闭期间可以下单的时间段" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.closeAddOrderTime }}</template>
          </el-table-column> -->
          <el-table-column label="省级编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.provinceCode }}</template>
          </el-table-column>
          <el-table-column label="省级名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.provinceName }}</template>
          </el-table-column>
          <el-table-column label="市级编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.cityCode }}</template>
          </el-table-column>
          <el-table-column label="市级名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.cityName }}</template>
          </el-table-column>
          <el-table-column label="区级编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.areaCode }}</template>
          </el-table-column>
          <el-table-column label="区级名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.areaName }}</template>
          </el-table-column>
          <!-- <el-table-column label="图片宽度（像素）" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.imgWidth }}</template>
          </el-table-column>
          <el-table-column label="图片高度（像素）" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.imgHeight }}</template>
          </el-table-column>
          <el-table-column label="文件大小（字节）" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.fileSize }}</template>
          </el-table-column>
          <el-table-column label="图片格式" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.imgFormat }}</template>
          </el-table-column>
          <el-table-column label="水平分辨率（DPI）" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.resolutionX }}</template>
          </el-table-column>
          <el-table-column label="垂直分辨率（DPI）" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.resolutionY }}</template>
          </el-table-column>
          <el-table-column label="经营范围" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.businessScope }}</template>
          </el-table-column> -->
        <el-table-column label="操作" width="135" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)" size="small">编辑</el-button>
            <el-popconfirm title="确定删除吗？" @confirm="handleDelte(scope.row.id)">
              <el-button slot="reference" type="text">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="(labelType=='add'?'新增':'编辑')" :visible.sync="showDialog" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">

            <!-- <el-col :span="12">
              <el-form-item label="id：" prop="siteName">
                <el-input v-model="form.id" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商家编码：" prop="siteName">
                <el-input v-model="form.merchantCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="商家名称：" prop="siteName">
                <el-input v-model="form.merchantName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入驻类型：" prop="siteName">
                <el-input v-model="form.settleType" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人：" prop="siteName">
                <el-input v-model="form.linkName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系手机号：" prop="siteName">
                <el-input v-model="form.linkPhone" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营业时间：" prop="siteName">
                <el-input v-model="form.openingTime" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营业地址：" prop="siteName">
                <el-input v-model="form.address" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="商家描述：" prop="siteName">
                <el-input v-model="form.merchantDesc" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="营业执照：" prop="siteName">
                <el-input v-model="form.businessLicense" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入驻支付类型：" prop="siteName">
                <el-input v-model="form.payType" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态：" prop="siteName">
                <el-input v-model="form.status" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="创建日期：" prop="siteName">
                <el-input v-model="form.createDt" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商家logo：" prop="siteName">
                <el-input v-model="form.logo" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建人：" prop="siteName">
                <el-input v-model="form.creator" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度：" prop="siteName">
                <el-input v-model="form.latitude" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="经度：" prop="siteName">
                <el-input v-model="form.longitude" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="通用费率：" prop="siteName">
                <el-input v-model="form.generalRate" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="微信费率：" prop="siteName">
                <el-input v-model="form.wxRate" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付宝费率：" prop="siteName">
                <el-input v-model="form.alipayRate" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="线上订单流水号：" prop="siteName">
                <el-input v-model="form.onlineTransNo" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否发送短信：：" prop="siteName">
                <el-input v-model="form.isSms" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="温馨提示：" prop="siteName">
                <el-input v-model="form.reminder" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关闭开始时间：" prop="siteName">
                <el-input v-model="form.closeStartTime" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关闭结束时间：" prop="siteName">
                <el-input v-model="form.closeEndTime" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="关闭期间可以下单的时间段：" prop="siteName">
                <el-input v-model="form.closeAddOrderTime" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="省级编码：" prop="siteName">
                <el-input v-model="form.provinceCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="省级名称：" prop="siteName">
                <el-input v-model="form.provinceName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="市级编码：" prop="siteName">
                <el-input v-model="form.cityCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="市级名称：" prop="siteName">
                <el-input v-model="form.cityName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="区级编码：" prop="siteName">
                <el-input v-model="form.areaCode" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="区级名称：" prop="siteName">
                <el-input v-model="form.areaName" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="图片宽度（像素）：" prop="siteName">
                <el-input v-model="form.imgWidth" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图片高度（像素）：" prop="siteName">
                <el-input v-model="form.imgHeight" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="文件大小（字节）：" prop="siteName">
                <el-input v-model="form.fileSize" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图片格式：" prop="siteName">
                <el-input v-model="form.imgFormat" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="水平分辨率（DPI）：" prop="siteName">
                <el-input v-model="form.resolutionX" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="垂直分辨率（DPI）：" prop="siteName">
                <el-input v-model="form.resolutionY" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="12">
              <el-form-item label="经营范围：" prop="siteName">
                <el-input v-model="form.businessScope" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col> -->
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 256, //表格高度
      headerHeight: 0,
      loading:false,
      overDate: [], //到期时间
    };
  },

  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight;
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 186;
    },

    //获取数据
    getList () {
	  var that = this;
    that.loading = true
	  that.$http.post("/merchant/list", that.queryInfo).then(function (response) {
        console.log(response.data.data);
        if (response.data.code == 200) {
          that.loading = false
          that.total = response.data.data.count;
          that.queryInfo.currPage=response.data.data.currPage
          that.tableData = response.data.data.data;
        }
      });
    },

    // 保存
    handleSave () {
	    var that = this;
      if(!this.form.merchantCode){
        // 时间戳
        const timestamp = Date.now().toString();
        // 随机数
        const randomStr = Math.random().toString(6).slice(-4);

        // 组合编码
        this.form.merchantCode = `mcode${timestamp}${randomStr}`
      }
      that.$http.post("/merchant/save", that.form).then(function (response) {
        if (response.data.code == 200) {
          that.$notify.success({
            title: "提示",
            message: "保存成功",
            showClose: true,
          });
          that.showDialog = false
          that.getList()
        }else{
          that.$notify.info({
          title: "提示",
          message: response.data.message,
          showClose: true,
          });
        }
      }).catch(function(error){


      })
	  
	  
    },

    //修改
    edit (row) {
      this.showDialog = true;
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
    },

    // 删除当前行
//    handleDelte (id) {
//      del({ id: id }).then(res => {
//        if (res.code == 200) {
 //         this.$message.success('删除成功')
 //         this.getList()
 //       }
//      })
//    },
	
	// 删除用户
    async handleDelte(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
           var that = this;
        that.$http.post("/merchant/delete" ,{"id":id}).then(function (response) {
			if(response.data.code == 200){
			 that.$notify.success({
				title: "提示",
				message: "删除成功",
				showClose: true,
			  });
			  that.getList();
			}else{
				 that.$notify.info({
					title: "提示",
					message: response.data.message,
					showClose: true,
				  });
			}
         
        });
      }
    },

    //新增按钮
    newBtn () {
      this.labelType = 'add'
      this.showDialog = true;
      this.form = {}
    },
    //搜索
    search() {
      this.queryInfo.condition.startTime = this.overDate[0];
      this.queryInfo.condition.endTime = this.overDate[1];
      this.queryInfo.currPage = 1
      this.getList();
    },
    //重置
    reset() {
      this.overDate = [];
      this.queryInfo.condition = {};
      this.search();
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val;
      this.search()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val;
      this.getList()
    },

  },
};
</script>

<style lang="scss" scoped>
.main-container{
  ::-webkit-scrollbar-thumb{
    background-color: #a5a5a5;
  }
}
</style>

